<script setup lang="ts">
  import { AvatarRoot } from 'reka-ui'
  import type { HTMLAttributes } from 'vue'
  import { cn } from '../../../lib/utils'
  import { avatarVariant, type AvatarVariants } from './avatar-variants'

  const props = withDefaults(
    defineProps<{
      class?: HTMLAttributes['class']
      size?: AvatarVariants['size']
      shape?: AvatarVariants['shape']
    }>(),
    {
      size: 'sm',
      shape: 'circle'
    }
  )
</script>

<template>
  <AvatarRoot
    data-slot="avatar"
    :class="cn(avatarVariant({ size, shape }), props.class)"
  >
    <slot />
  </AvatarRoot>
</template>
